import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';

import { AdvancedSettings } from '../models/advancedSettings';

export class AdvancedSettingsService extends BaseService<AdvancedSettings> {
  override model = AdvancedSettings;
  override modelName = 'advancedSettings';
  override modelLabel = 'Advanced Settings';

  async inventoryReset(): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/inventoryReset`,
    });

    return await this.requestItem(request, AdvancedSettings);
  }

  async loyaltyReset(): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/loyaltyReset`,
    });

    return await this.requestItem(request, AdvancedSettings);
  }
}
